<template>
  <div class="selection d-flex align-items-center p-1">
    Aantal per pagina:

    <span
      v-for="number in availableValues"
      :key='typeof number === "number" ? number : number[0]'

      class="number p-1 px-2"
      :class='{active: page_size === (typeof number === "number" ? number : number[1])}'
      @click="selectItem(number)"
    >
      {{ typeof number === "number" ? number : number[0] }}
    </span>
  </div>
</template>

<script>

export default {
  props: {
    value: {
      type: Number,
      required: true,
    },
    availableValues: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      page_size: this.value,
    }
  },
  methods: {
    selectItem(number) {
      this.page_size = typeof number === "number" ? number : number[1]
    },
  },
  watch: {
    value(val) {
      this.page_size = val
    },
    page_size(val) {
      this.$emit("input", val)
    },
  },
}

</script>

<style scoped>

.selection, .number {
  border-radius: 1px;
}

.selection {

}

.number {
  display: inline-block;
  background-color: transparent;
  cursor: pointer;
  z-index: 1;
  transition-duration: .2s;
  border: 1px solid transparent;
}

.number:hover {
  font-weight: bold;
}

.number.active {
  text-decoration: underline;
text-underline-position: from-font;
}

</style>
